import { render, staticRenderFns } from "./basicMaintainerEdit.vue?vue&type=template&id=9d9cf7d8&scoped=true"
import script from "./basicMaintainerEdit.vue?vue&type=script&lang=js"
export * from "./basicMaintainerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9cf7d8",
  null
  
)

export default component.exports